<template>
  <b-modal
    id="veify-modal" :visible="shallShowModal" centered
    footer-class="d-flex justify-content-between"
    body-class="px-2" size="md" no-close-on-backdrop static
    @change="(val) => $emit('update:shall-show-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title"> 延长保护期 </h5>
      <div class="modal-actions">
        <feather-icon icon="XIcon" class="ml-1 cursor-pointer" @click="$emit('update:shall-show-modal', false)" />
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <div>
        <b-button variant="outline-secondary" class="cursor-pointer"
          @click="$emit('update:shall-show-modal', false)"
        >
          取消
        </b-button>
      </div>

      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="primary" class="mb-1 mb-sm-0"
          @click="updateForm"
        >
          确定
        </b-button>
      </div>
    </template>

    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <!-- days -->
          <b-col cols="12">
            <b-form-group label="保护期延长设置" label-for="days">
              <validation-provider name="保护期天数" #default="{ errors }" rules="required">
                <b-input-group prepend="保护期从今日起往后延长" append="天" >
                  <b-form-input number type="number" v-model="days" placeholder="30" id="days" :state="errors.length > 0 ? false:null" />
                </b-input-group>
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

  </b-modal>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  directives: {
    Ripple,
  },
  components: {
    formValidation,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
  },
  model: {
    prop: 'shallShowModal',
    event: 'update:shall-show-modal',
  },
  props: {
    shallShowModal: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: false,
    },
  },
  setup(props, { emit }) {
    /* 必要组件加载区域 */

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */

    // 表单验证dom对象
    const refFormObserver = ref(null)
    // 表单数据项
    const days = ref(30)
    // 表单数据清空函数
    const resetFormData = () => {
      days.value = 30
      refFormObserver.value.reset()
    }

    /* 接口调用区域 */

    // 保存 处理编辑
    const updateForm = () => {
      refFormObserver.value.validate().then(success => {
        if (success) {
          emit('up-days', props.id, days.value)
          emit('update:shall-show-modal', false)
        }
      })
    }

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    // 编辑窗口关闭，清空表单并刷新验证
    watch(() => props.shallShowModal, val => { if (!val) { resetFormData() } })

    return {
      days,
      refFormObserver,
      resetFormData,
      updateForm,

      required,
    }
  },
}
</script>
